<div class="main-content datos-personales-page">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-10">
        <section class="datos-card">
          <div class="datos-card__header">
            <div class="datos-card__title">
              <i class="material-icons">sync_alt</i>
              <span>Tokens de integración</span>
            </div>
          </div>

          <form [formGroup]="formGroupUsuario" class="datos-card__body">
            <div class="row datos-grid datos-grid--single">
              <div class="col-12">
                <div class="datos-field-wrap">
                  <label class="datos-field-wrap__label" for="token">GitLab Token</label>
                  <mat-form-field appearance="outline" class="datos-field datos-field--with-errors">
                    <mat-icon matPrefix>code</mat-icon>
                    <input
                      id="token"
                      type="password"
                      name="token"
                      maxlength="25"
                      matInput
                      [(ngModel)]="usuarioObj.token_personal"
                      oninput="this.value = this.value.trim()"
                      formControlName="ctrlToken"
                    >
                    <mat-error *ngIf="formUsuar.ctrlToken.dirty && formUsuar.ctrlToken.errors">
                      El token de GitLab no puede estar vacío
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-12">
                <div class="datos-field-wrap">
                  <label class="datos-field-wrap__label" for="tokenAzure">Azure Token</label>
                  <mat-form-field appearance="outline" class="datos-field datos-field--with-errors">
                    <mat-icon matPrefix>cloud_done</mat-icon>
                    <input
                      id="tokenAzure"
                      type="password"
                      name="tokenAzure"
                      maxlength="60"
                      matInput
                      [(ngModel)]="usuarioObj.token_azure"
                      oninput="this.value = this.value.trim()"
                      formControlName="ctrlTokenAzure"
                    >
                    <mat-error *ngIf="formUsuar.ctrlTokenAzure.dirty && formUsuar.ctrlTokenAzure.errors">
                      El token de Azure no puede estar vacío
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="datos-inline-note">
              <div class="datos-inline-note__icon">
                <i class="material-icons">sync_alt</i>
              </div>
              <span>Estos tokens se utilizan para sincronizar integraciones con GitLab y Azure Boards.</span>
            </div>

            <div class="datos-card__divider"></div>

            <div class="datos-card__actions">
              <button
                type="button"
                mat-raised-button
                class="btn datos-btn datos-btn--secondary"
                (click)="cancelar()"
              >
                Cancelar
              </button>

              <button
                type="button"
                mat-raised-button
                class="btn datos-btn datos-btn--primary"
                [disabled]="formGroupUsuario.invalid"
                (click)="actualizaToken()"
              >
                Guardar cambios
              </button>
            </div>
          </form>
        </section>

        <section class="datos-support">
          <div class="datos-support__icon">
            <i class="material-icons">hub</i>
          </div>

          <div class="datos-support__copy">
            <strong>¿Problemas con tus integraciones?</strong>
            <span>Si la sincronización falla después de actualizar tus tokens, valida permisos y caducidad con el área de Sistemas.</span>
          </div>

          <div class="datos-support__cta">Integraciones</div>
        </section>
      </div>
    </div>
  </div>
</div>
